import { forwardRef, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Button, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";

const Separator = styled("div")(
  ({ theme }) => `
  height: ${theme.spacing(3)};
`
);

const CustomSlider = withStyles({
  markLabel: {
    fontSize: "9px",
  },
})(Slider);

const index = forwardRef(
  (
    {
      payload,
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayloadB2B,
      handlePayloadB2C,
      latestStepQuestion,
      isEdit,
      nonLinearValueB2B,
      nonLinearValueB2C,
    },
    ref
  ) => {
    const [mark1, setMark1] = useState(null);
    const [mark2, setMark2] = useState(null);
    const isMobile = useMediaQuery("(max-width:900px)");

    useEffect(() => {
      if (payload?.model_A.includes("B2B")) {
        const mark = data?.marksB2B.find(
          (el) => el.scaledValue === nonLinearValueB2B
        );
        setMark1(mark.value);
      }
    }, [nonLinearValueB2B, payload?.model_A]);

    useEffect(() => {
      if (payload?.model_A.includes("B2C")) {
        const mark = data?.marksB2C.find(
          (el) => el.scaledValue === nonLinearValueB2C
        );
        setMark2(mark.value);
      }
    }, [nonLinearValueB2C, payload?.model_A]);

    const nextQuestionHandler = (height) => {
      if (payload?.model_A.includes("B2B")) {
        handlePayloadB2B(data, nonLinearValueB2B);
      } else {
        handlePayloadB2B(data, 0);
      }

      if (payload?.model_A.includes("B2C")) {
        handlePayloadB2C(data, nonLinearValueB2C);
      } else {
        handlePayloadB2C(data, 0);
      }
      scrollToQuestion(data, height, nonLinearValueB2C, nonLinearValueB2B);
    };

    const scaleB2B = (value) => {
      const previousMarkIndex = Math.floor(value / data.step);
      const previousMark = data.marksB2B[previousMarkIndex];
      return previousMark.scaledValue;
    };

    const scaleB2C = (value) => {
      const previousMarkIndex = Math.floor(value / data.step);
      const previousMark = data.marksB2C[previousMarkIndex];
      return previousMark.scaledValue;
    };

    const handleSliderChangeB2B = (event, newValue) => {
      handlePayloadB2B(data, scaleB2B(newValue));
    };

    const handleSliderChangeB2C = (event, newValue) => {
      handlePayloadB2C(data, scaleB2C(newValue));
    };
    const { t } = useTranslation();
    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          {payload?.model_A.includes("B2B") && (
            <>
              <Typography variant="subtitle1">
                {t("display_clients_number_A_B2B")}
              </Typography>
              <br></br>
              {isMobile ? (
                <Box>
                  <CustomSlider
                    value={mark1}
                    min={data.min}
                    step={data.step}
                    max={data.maxB2B}
                    marks={data.marksB2B}
                    onChange={handleSliderChangeB2B}
                    aria-labelledby="non-linear-slider"
                  />
                  <Separator />
                </Box>
              ) : (
                <Box>
                  <Slider
                    value={mark1}
                    min={data.min}
                    step={data.step}
                    max={data.maxB2B}
                    marks={data.marksB2B}
                    onChange={handleSliderChangeB2B}
                    aria-labelledby="non-linear-slider"
                  />
                  <Separator />
                </Box>
              )}
            </>
          )}

          {payload?.model_A.includes("B2C") && (
            <>
              <Typography variant="subtitle1">
                {t("display_clients_number_A_B2C")}
              </Typography>
              <br></br>
              {isMobile ? (
                <Box>
                  <CustomSlider
                    value={mark2}
                    min={data.min}
                    step={data.step}
                    max={data.maxB2C}
                    marks={data.marksB2C}
                    onChange={handleSliderChangeB2C}
                    aria-labelledby="non-linear-slider"
                  />
                  <Separator />
                </Box>
              ) : (
                <Box>
                  <Slider
                    value={mark2}
                    min={data.min}
                    step={data.step}
                    max={data.maxB2C}
                    marks={data.marksB2C}
                    onChange={handleSliderChangeB2C}
                    aria-labelledby="non-linear-slider"
                  />
                  <Separator />
                </Box>
              )}
            </>
          )}
          {currentQuestion === data.id &&
          currentQuestion !== latestQuestion &&
          !(isEdit && latestStepQuestion === data.id) ? (
            <>
              {" "}
              <Button
                onClick={() => {
                  nextQuestionHandler(ref.current.clientHeight);
                }}
                style={{ height: "50px" }}
                color="secondary"
                variant="contained"
                fullWidth
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default index;
